import PhaseSixIcon, { type TIconNames } from "../phaseSixIcon/PhaseSixIcon";

interface IconTextRowProps {
    "data-testid"?: string;
    icon: TIconNames;
    text: string;
    iconClassName?: string;
    textClassName?: string;
    role?: string;
}

const IconTextRow = (props: IconTextRowProps) => {
    return (
        <div
            className="flex gap-xs items-center"
            data-testid={props["data-testid"]}
            role={props.role}
        >
            <PhaseSixIcon
                name={props.icon}
                className={`${props.iconClassName ?? "text-xl text-p6-grey-dark"} shrink-0`}
            />
            <span className={props.textClassName ?? "text-l text-p6-grey-dark"}>{props.text}</span>
        </div>
    );
};

export default IconTextRow;
